import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { GroupIcon, UngroupIcon } from "@/icons/widget-menu";
import { widgetMenuAvailableOptions } from "@/interface/AppStore";
import { TOOLTIP_BUTTON_CLASS } from "../../constants/tooltipButtonClass";
import type { SetActiveSubMenu } from "../../types";
import { MenuButton } from "../MenuButton/MenuButton";

type GroupAction = "group" | "ungroup";

interface GroupButtonsProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function GroupButtons({ setActiveSubMenu }: GroupButtonsProps) {
    useAtomValue(widgetMenuAvailableOptions);

    // если среди выбранных есть элемент с parent - не даем дальше группировать
    // если среди выбранных есть сгруппированные элементы, то показываем разгруппировать и сгруппировать
    // если среди выбранных нет сгруппированных элементов, то показываем только сгруппировать
    const hasGrouped =
        canv.canvasController.selected.findIndex((item) => !item.isItemWrapper()) !== -1;
    const hasBeenGrouped = canv.canvasController.selected.findIndex((item) => item.parent) !== -1;

    const handleButtonClick = (action: GroupAction) => {
        setActiveSubMenu(null);

        canv.canvasController.groupProccessor(action === "group" ? "group" : "ungroup");
    };

    if (canv.canvasController.selected.length === 1) {
        return (
            <MenuButton
                className={TOOLTIP_BUTTON_CLASS}
                onClick={() => handleButtonClick("ungroup")}
                data-tooltip="Разгруппировать"
            >
                <UngroupIcon />
            </MenuButton>
        );
    }

    return (
        <>
            {!hasBeenGrouped && (
                <MenuButton
                    className={TOOLTIP_BUTTON_CLASS}
                    onClick={() => handleButtonClick("group")}
                    data-tooltip="Сгруппировать"
                >
                    <GroupIcon />
                </MenuButton>
            )}
            {hasGrouped && (
                <MenuButton
                    className={TOOLTIP_BUTTON_CLASS}
                    onClick={() => handleButtonClick("ungroup")}
                    data-tooltip="Разгруппировать"
                >
                    <UngroupIcon />
                </MenuButton>
            )}
        </>
    );
}
